import React from 'react';
import { get } from 'lodash';

import TableHeader from './TableHeader';
import GameFormModal from './GameFormModal';
import ModalDelete from './ModalDelete';
import ImageLoader from './ImageLoader';
import PlatformDetails from './PlatformDetails';
import IntegrationModal from './game_integrations/IntegrationModal';

const GamesList = ({ games = [], total = 0 }) => {
  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>Games list</h2>
          <p className='MainHeader__left__p'>Total {total.toLocaleString()} games</p>
        </div>

        <div className='MainHeader__right'>
          <GameFormModal
            klassName='MainHeader__right__a MainHeader__right__a--bright-blue'
            label='Add Game'
            title='Add Game'
            reload
          />
        </div>
      </div>

      <div className='Table Table--games-list'>
        {(() => {
          const columnHeaders = [
            {
              label: 'ID',
              sortKey: 'id',
            },
            {
              label: 'Position',
              sortKey: 'position'
            },
            {
              label: 'Icon',
            },
            {
              label: 'Title',
              sortKey: 'title'
            },
            {
              label: 'iOS'
            },
            {
              label: 'Android'
            },
            {
              label: 'Manage',
            },
          ]

          return (
            <div className='Table__row'>
              {columnHeaders.map((header, key) => (
                <TableHeader
                  key={key}
                  header={header}
                />
              ))}
            </div>
          )
        })()}

        {games.map((game) => (
          <div className={'Table__row'} key={`game_${game.id}`}>
            <div className='Table__col'>{game.id}</div>

            <div className='Table__col'>{game.position}</div>

            <div className='Table__col'>
              <ImageLoader url={game.iconUrl} />
            </div>

            <div className='Table__col'>{game.title}</div>

            <div className='Table__col'>
              <PlatformDetails
                gameId={game.id}
                platform={'ios'}
                details={get(game, "platformDetails.ios")}
               />
            </div>

            <div className='Table__col'>
              <PlatformDetails
                gameId={game.id}
                platform={'android'}
                details={get(game, "platformDetails.android")}
              />
            </div>

            <div className='Table__col'>
              <div className='Table__controls'>
                <GameFormModal
                  klassName='Table__controls__a Table__controls__a--pencil'
                  title='Edit Game'
                  game={game}
                  reload
                />
                <IntegrationModal gameId={game.id} />
                <ModalDelete
                  type='game'
                  id={get(game, 'id')}
                  klassName='Table__controls__a Table__controls__a--trash'
                  reload
                  hideText
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}

export default GamesList
